import React from 'react'
import { ILibraryFolder, useLibrary } from 'hooks/useLibrary'
import { LibraryTemplate } from 'components/templates/LibraryTemplate'

export const LibraryView = (folder: ILibraryFolder) => {
  const { staticData, t, isLoading } = useLibrary()

  return <LibraryTemplate {...staticData} folder={folder} t={t} isLoading={isLoading} />
}
